<template>
  <component :is="wrappedMolecule" v-bind="{...model, ...common}"/>
</template>
<script>
  import {mgnlComponentMixin} from "@wl-vue-mixins/mixins.js";

  export default {
    mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!

    name: "MgnlDynamicWrapper",

    props: {
        wrappedMolecule: {
            type: String,
            required: true
        }
    },

    components: {
        // insert here the dynamic imports of the molecule than need to be supported by a Mgnl Wrapper
        Listing: () => import("../Listing/Listing.vue"),
        CardArticleFeatured: () => import ("../Card-Article-Featured/Card-Article-Featured"),
        FinancialSimulator: () => import("../FinancialSimulator/FinancialSimulator"),
        HeroHeading: () => import("../HeroHeading/HeroHeading"),
        HeroHeadingCommunity: () => import("../HeroHeadingCommunity/HeroHeadingCommunity"),
        HomepageOverlay: () => import("../HomepageOverlay/HomepageOverlay"),
        Disclaimer: () => import("../Disclaimer/Disclaimer"),
        DealerLocatorDetail: () => import("../DealerLocatorDetail/DealerLocatorDetail"),
        AnchorsMenu: () => import("../AnchorsMenu/AnchorsMenu"),
        EditorialAccordion: () => import("../EditorialAccordion/EditorialAccordion"),
        FormContact: () => import("../FormContact/FormContact"),
        FormContactC4c: () => import("../FormContactC4c/FormContactC4c"),
        FormContactPiaggiogroup: () => import("../FormContactPiaggiogroup/FormContactPiaggiogroup"),
        WarrantyExtension: () => import("../WarrantyExtension/WarrantyExtension"),
        Countries: () => import("../Countries/Countries"),
        ModelVersionSelector: () => import("../ModelVersionSelector/ModelVersionSelector"),
        CallToAction: () => import("../Call-To-Action/Call-To-Action"),
        SimpleImage: () => import("../SimpleImage/SimpleImage"),
        ValidateCr: () => import("../ValidateCr/ValidateCr"),
        Flowbox: () => import("../Flowbox/Flowbox"),
        AnimatedMedia: () => import("../AnimatedMedia/AnimatedMedia"),
        GalleryPremium: () => import("../GalleryPremium/GalleryPremium"),
        WallImage: () => import("../WallImage/WallImage"),
        HubLinks: () => import("../HubLinks/HubLinks"),
        BannerFull: () => import("../BannerFull/BannerFull"),
        TestrideLanding: () => import("../TestrideLanding/TestrideLanding"),
        TestrideBrand: () => import("../TestrideBrand/TestrideBrand"),
        CardBig: () => import("../CardBig/CardBig"),
        CardBigCommunity: () => import("../CardBigCommunity/CardBigCommunity"),
        CardSmall: () => import("../CardSmall/CardSmall"),
        CardSmallCommunity: () => import("../CardSmallCommunity/CardSmallCommunity"),
        FamilyShowcase: () => import('../FamilyShowcase/FamilyShowcase'),
        HeroSingleContent: () => import('../HeroSingleContent/HeroSingleContent'),
        GigyaCommunity: () => import('../GigyaCommunity/GigyaCommunity'),
        GigyaAppCommunity: () => import('../GigyaAppCommunity/GigyaAppCommunity'),
        PromotionCtaList: () => import('../PromotionCtaList/PromotionCtaList.vue'),
        FormUpload: () => import("../FormUpload/FormUpload"),
        SendVINKeyboard: () => import('../SendVINKeyboard/SendVINKeyboard'),
        ListingEvents: () => import('../ListingEvents/ListingEvents'),
        MembershipCard: () => import("../MembershipCard/MembershipCard"),
        CommunitySupport: () => import('../CommunitySupport/CommunitySupport'),
        RecallCampaign: () => import('../RecallCampaign/RecallCampaign'),
        VisitEcommerce: () => import('../VisitEcommerce/VisitEcommerce.vue'),
        CarouselVehiclePremium: () => import('../CarouselVehiclePremium/CarouselVehiclePremium'),
        YouTubeIframe: () => import('../YouTubeLiveIframe/YouTubeLiveIframe'),
        CarouselFramed: () => import('../CarouselFramed/CarouselFramed'),
        ConfigurableFormWithMail: () => import('../ConfigurableFormWithMail/ConfigurableFormWithMail.vue'),
        LandingMenu: () => import('../LandingMenu/LandingMenu.vue'),
        FormPayment: () => import('../FormPayment/FormPayment.vue')
    }
  };
</script>
